// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__yheCy"};